<template>
  <div>
    <div class="market-definition-form">
      <div class="modal-body">
        <base-input
          v-model="formItems.name"
          inputType="text"
          labelText="Adı"
          :class="{ 'is-invalid': submitted && $v.formItems.name.$error }"
        />
        <div
          v-if="submitted && !$v.formItems.name.required"
          class="invalid-feedback"
        >
          {{ invalidMessage }}
        </div>
        <base-input
          v-model="formItems.shortContent"
          inputType="text"
          labelText="Kısa Tanım"
        />
        <base-input
          v-model="formItems.description"
          inputType="text"
          labelText="Açıklama"
        />
      </div>
      <div class="modal-bottom">
        <base-button class="giveUp" @click="$modal.hide('modal')"
          >Vazgeç</base-button
        >
        <base-button @click="sendForm" class="add"> Kaydet </base-button>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.invalid-feedback {
  color: red;
  font-size: 12px;
  margin-top: 5px;
  padding-left: 10px;
}
.is-invalid {
  input {
    border: 1px solid red !important;
  }
}
</style>

<script>
import { required } from "vuelidate/lib/validators";
import { BaseInput, BaseButton } from "@/components";

export default {
  validations: {
    formItems: {
      name: { required },
    },
  },
  name: "MarketDefinitionForm",
  components: {
    BaseInput,
    BaseButton,
  },
  props: {
    clickedNewItemBtn: Boolean,
    id: Number,
    selectedDataId: Number,
    selectedDataName: String,
    selectedShortContent: String,
    selectedDescription: String,
    shortContent: String,
    description: String,
    selectedDataOrder: Number,
    InsertUpdateForm: {
      type: Function,
    },
  },
  data() {
    return {
      clickedNewBtn: this.clickedNewItemBtn,
      submitted: false,
      formItems: {
        id: this.selectedDataId,
        name: this.selectedDataName,
        shortContent: this.selectedShortContent,
        description: this.selectedDescription,
        order: this.selectedDataOrder,
      },
      invalidMessage: "Bu alan boş bırakılamaz!",
    };
  },
  methods: {
    sendForm() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      if (this.clickedNewItemBtn) {
        delete this.formItems.id;
        delete this.formItems.order;
      }
      this.$emit("submit-form", this.formItems);
    },
  },
};
</script>
